import { render } from "./Face.vue?vue&type=template&id=31bf01cc&scoped=true"
import script from "./Face.vue?vue&type=script&lang=js"
export * from "./Face.vue?vue&type=script&lang=js"

import "./Face.vue?vue&type=style&index=0&id=31bf01cc&scoped=true&lang=css"
import "./Face.vue?vue&type=style&index=1&id=31bf01cc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bf01cc"]])

export default __exports__